import api from '../api';

class SessionsApi {

    constructor() {
        this.endpoint = 'sessions';
    }

    create = (data) => {
        return api.post(this.endpoint + '?essential', data);
    }

    getById = (id, data) => {
        return api.get(this.endpoint + '/' + id, data);
    }

    getPermissionsByUser = (id, data) => {
        return api.get('permissions/users/' + id, data);
    }
}

const instance = new SessionsApi();

export default instance;